module.exports = __webpack_public_path__ + "img/img41.b77670a8.jpg";